import React from "react";
import { Box, Card, Container, Stack, Typography } from "@mui/material";
import Logo from '../../assets/img/logo_full.png'
import Fludee from '../../assets/img/FLUDEE BLACK CROP TRADEMARK.png'
export default function BrandHeader() {
  return (
    <Container maxWidth="md" sx={{ mt: 3, mb: 2 }}>
      <Card sx={{ borderRadius: 4, backgroundColor: "rgba(255,255,255,0.9)", boxShadow: 4, p: 2 }}>
        <Stack direction={{ xs: "column", md: "row" }} alignItems="center" justifyContent="space-between" spacing={2}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Box
              component="img"
               src={Logo}
              alt="Company Logo"
              sx={{ width: 60, height: 60, borderRadius: 2, objectFit: "contain" }}
            />
            <Box>
              <Typography variant="h6" fontWeight={900}>Sudhanshu & Siddharth Innovations Pvt.Ltd.</Typography>
              <Typography variant="h6" fontWeight={900}>FeedBack form</Typography>
              <Typography variant="body2" color="text.secondary">FLUDEE – Real-time Fluid Monitoring</Typography>
            </Box>
          </Stack>

          <Box
            component="img"
           src={Fludee}
            alt="FLUDEE"
            sx={{ width: { xs: "100%", md: 220 }, height: 90, objectFit: "contain" }}
          />
        </Stack>
      </Card>
    </Container>
  );
}
